// extracted by mini-css-extract-plugin
module.exports = {"theme":"#1989fa"};